.open {
  display: block;
  height: auto;
  background-color: #f1f1f1;
}

.close {
  display: none;
}

ul,
li {
  list-style: none;
}

ul {
  padding: 0px 0px;
  margin: 0px 0px;
}

li {
  height: 30px;
  color: rgb(38, 38, 38);
  font-size: 20px;
  font-family: 'acumin-pro', Helvetica, Arial, sans-serif;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 30px;
  padding: 8px 16px;
}

li:hover,
li:focus {
  background: rgb(242, 245, 248);
  border-radius: 0px;
  cursor: pointer;
}

.dropdown-button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 48px;
  border: 1px solid rgb(168, 168, 168);
  color: rgb(38, 38, 38);
  font-size: 20px;
  font-family: 'acumin-pro', Helvetica, Arial, sans-serif;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 30px;
}

.content-box {
  border: 1px solid rgb(168, 168, 168);
  border-radius: 0px;
  background-color: #fff;
  font-family: 'acumin-pro', Helvetica, Arial, sans-serif;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
